export enum EsgValueType {
  Percent = 'PERCENT',
  Tonne = 'TONNE',
  Score = 'SCORE',
}
